import React, { useState } from 'react';
import { PDFViewer, Document, Page, Image, Text, View, StyleSheet, Font, Svg, Link } from "@react-pdf/renderer";
import rgpd from '../../images/auditoria_lopd.jpg'
import contratos from '../../images/documentacion-contratos.png'
import Firma from '../../images/Firma-Lae-Consulting.jpg'
import { withRouter } from '../../providers/withRouter';
import { useEffect } from 'react';
import { getSale } from '../../services';
import { decryptParameter, formatoFechasEs } from '../../functions/funciones';
import CircularProgress from '@mui/material/CircularProgress';
import Logo from '../../images/LogoLAE.png'
import RobotoRegular from "../../fonts/Roboto-Regular.ttf"
import RobotoBold from "../../fonts/Roboto-Bold.ttf"
import RobotoItalic from "../../fonts/Roboto-Italic.ttf"
import RobotoBoldItalic from "../../fonts/Roboto-BoldItalic.ttf"
import { FaRegSquare } from "react-icons/fa6";
import { IconToSvg } from './IconToSvg';
import PDFHandler from "./PDFHandler";
import { useTranslation } from "react-i18next";

Font.register({
    family: 'Roboto',
    fonts: [
      { src: RobotoItalic, fontWeight: 400 },
      { src: RobotoRegular, fontWeight: 400 },
      { src: RobotoBold, fontWeight: 700 },
      { src: RobotoBoldItalic, fontWeight: 800 },
    ]
});

const DocumentacionLOPD = (props) => {
        const { t } = useTranslation('pdfs');

        const styles = StyleSheet.create({
            docTitle: {
                position: 'absolute',
                left: 70,
                right: 70,
                bottom: '70px',
                textAlign: 'center',
                fontSize: '16px',
                color: '#B50655'|| '#023867',
                fontFamily: 'Roboto',
                fontWeight: 700,
                textTransform: 'uppercase'
            },
            body: {
                paddingBottom: 65,
                paddingHorizontal: '0cm',
            },
            h1: {
                marginBottom: '30px',
                fontSize: '14px',
                fontFamily: 'Roboto',
                fontWeight: 700
            },
             h2: {
                fontSize: '11px',
                fontFamily: 'Roboto',
                fontWeight: 700,
                marginTop: '10px',
                marginBottom: '10px',
            },
            h3: {
                fontSize: '12px',
                width: '100%',
                padding: '5px 10px',
                // backgroundColor: '#f8f8f8',
                textTransform: 'uppercase',
                // border: '1px solid #e6e6e6',
                // marginTop: '20px',
                marginBottom: '15px',
                fontFamily: 'Roboto',
                fontWeight: 700
            },
            h4: {
                // color: '#ab2a3e',
                marginBottom: '10px',
                marginTop: '20px',
                fontSize: '10px',
                padding: '5px 10px',
                fontFamily: 'Roboto',
                fontWeight: 700
            },
            h5: {
                fontSize: '9px',
                marginTop: '15px',
                marginBottom: '5px',
            },
            p: {
                lineHeight: '1.8',
                textAlign: 'justify',
                padding: '5px 10px',
                /* marginLeft:'2cm',
                marginRight:'2cm', */
                fontSize: '9px',
            },
            ul: {
                // lineHeight: '1.8',
                // fontSize:'7px',
                paddingLeft: 10,
                marginVertical: 8,
                flexDirection: "column", 
            },
            ol: {
                lineHeight: '1.8',
                flexDirection: "row", 
                marginBottom: 4,
                fontSize: '9px',
            },
            br: {
                display: 'block',
                margin: '10px 0 2px 0',
                lineHeight: '5px',
                content: " ",
            },
            table: { 
                display: "table", 
                width: "100%", 
                borderStyle: "solid", 
                borderWidth: 1, 
                borderRightWidth: 0, 
                borderBottomWidth: 0, 
                margin:'auto'
                // padding:'25px 0'
            }, 
            tableRow: { 
                margin: "auto", 
                flexDirection: "row" 
            }, 
            tableCol: { 
                width: "50%", 
                borderStyle: "solid", 
                borderWidth: 1, 
                borderLeftWidth: 0, 
                borderTopWidth: 0,
                display: 'flex',
                justifyContent:'center',
                alignItems:'left'
            }, 
            tableColIzq: { 
                width: "25%", 
                borderStyle: "solid", 
                borderWidth: 1, 
                borderLeftWidth: 0, 
                borderTopWidth: 0,
                display: 'flex',
                justifyContent:'center',
                alignItems:'left'
            }, 
            tableColDer: { 
                width: "75%", 
                borderStyle: "solid", 
                borderWidth: 1, 
                borderLeftWidth: 0, 
                borderTopWidth: 0,
                display: 'flex',
                justifyContent:'center',
                alignItems:'left'
            }, 
            tableCell: { 
                margin: "auto", 
                marginTop: 5, 
                marginBottom: 5, 
                marginLeft:2,
                marginRight: 2,
                fontSize: 8 
            },
            tableRowHeader: { 
                marginTop:"30px",
                margin: "auto", 
                flexDirection: "row" 
            }, 
            tableColHeader: { 
                width: "100%", 
                borderStyle: "solid", 
                borderWidth: 1, 
                borderLeftWidth: 0, 
                borderTopWidth: 0,
                backgroundColor: '#c31e64',
                color: '#ffffff',
                display: 'flex',
                justifyContent:'center',
                alignItems:'center',
                fontSize: 14 
            }, 
            lista: {
                content: '✔',
                fontSize: 11,
                fontFamily: 'Roboto',
                fontWeight: 700,
                color:'#000000'
            },
            textoNormal: {
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: 10,
                fontStyle: 'normal',
            },
            textoItalic: {
                fontFamily: 'Roboto',
                fontWeight: 400
            },
            textoNegritaItalic: {
                fontFamily: 'Roboto',
                fontWeight: 800
            },
            textoNegrita: {
                fontFamily: 'Roboto',
                fontWeight: 700
            },
            icon: {
                width: 10,
                height: 10,
            },
            cuadrado: {
                width:10,
                height:10,
                border: '1px solid #000'
            },
            linea: {
                width:'90%', 
                height:'15px', 
                borderBottom: '1px solid #000000'

            },
            pageHeader: {
                marginTop: 20, 
                paddingBottom: 20, 
                marginHorizontal: '1cm'
            }
        })

    const backgroundImageUrl = rgpd; 

    const [isLoading, setIsLoading] = useState(true)
    const [finca, setFinca] = useState({})
    const [aaff, setAAFF] = useState({})
    const [detailsLOPD, setDetailsLOPD] = useState({})
    const [ProvSinAcceso, setProvSinAcceso] = useState([])

    
    const fechaActual = new Date();
    const nuevaFecha = new Date(fechaActual);
    const fechaVenta = nuevaFecha.setFullYear(fechaActual.getFullYear() + 1);
    

    useEffect(()=>{
        fetchData()
    },[])


    const fetchData = async () => {
        
        const response = await getSale(props.params.id)
        setFinca(response.properties)
        setAAFF(response.aaff)
        setDetailsLOPD(response.detailsLopd.find( item => item.sale_id === response.id))
        setProvSinAcceso(response.detailsLopd.find( item => item.sale_id === response.id).provsSinAcceso)
        
        setIsLoading(false)
    }

    const text = `${t('lopd.owners.medida1')} ${t('lopd.owners.medida2')}`;

    const maxLength = 100;  // Ajusta según la longitud máxima permitida en una página

    const contentArray = text.match(new RegExp(`.{1,${maxLength}}`, 'g')) || [];

    return ( 
        <>
            {isLoading ? <CircularProgress style={{color:'#92004D', position: 'absolute', top: '50%', left: '50%'}} /> :

                <PDFHandler style={{ width: "100%", height: "100vh" }}>
                    <Document size="A4" margin="2cm">
                        <Page>
                            <View>
                                <Image src={backgroundImageUrl} style={{ width: '100vw', height: '100vh' }}/>
                                <Text style={styles.docTitle}>
                            {finca.razonSocial}
                            </Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.section1.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section1.p1')}</Text>
                                <Text style={styles.p}>{t('lopd.section1.p2')}</Text>
                                <Text style={styles.p}>{t('lopd.section1.p3')}</Text>
                                <Text style={styles.p}>{t('lopd.section1.p4')}</Text>
                                <Text style={styles.p}>{t('lopd.section1.p5')}</Text>
                                <Text style={styles.p}>{t('lopd.section1.p6')}</Text>
                            </View>
                            <View style={{marginBottom: 20, paddingTop: 20, marginHorizontal: '1cm'}} fixed></View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.section2.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section2.intro')}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, { textDecoration: 'underline'}]}>{t('lopd.section2.registroTitle')}</Text>{t('lopd.section2.registroText')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, { textDecoration: 'underline'}]}>{t('lopd.section2.infoTitle')}</Text>{t('lopd.section2.infoText')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, { textDecoration: 'underline'}]}>{t('lopd.section2.principiosTitle')}</Text>{t('lopd.section2.principiosText')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, { textDecoration: 'underline'}]}>{t('lopd.section2.conservacionTitle')}</Text>{t('lopd.section2.conservacionText')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, { textDecoration: 'underline'}]}>{t('lopd.section2.comunicacionTitle')}</Text>{t('lopd.section2.comunicacionText')}</Text>
                                    </View>
                                        <View style={styles.ul}>
                                            <View style={[styles.ol, {paddingLeft: 20}]}>
                                                <Text style={{ marginHorizontal: 8 }}>•</Text>
                                                <Text style={{ width:280 }}>{t('lopd.section2.comunicacionItem1')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 20}]}>
                                                <Text style={{ marginHorizontal: 8 }}>•</Text>
                                                <Text style={{ width:280 }}>{t('lopd.section2.comunicacionItem2')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 20}]}>
                                                <Text style={{ marginHorizontal: 8 }}>•</Text>
                                                <Text style={{ width:280 }}>{t('lopd.section2.comunicacionItem3')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 20}]}>
                                                <Text style={{ marginHorizontal: 8 }}>•</Text>
                                                <Text style={{ width:280 }}>{t('lopd.section2.comunicacionItem4')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 20}]}>
                                                <Text style={{ marginHorizontal: 8 }}>•</Text>
                                                <Text style={{ width:280 }}>{t('lopd.section2.comunicacionItem5')}</Text>
                                            </View>
                                            <View style={[styles.ol, {paddingLeft: 20}]}>
                                                <Text style={{ marginHorizontal: 8 }}>•</Text>
                                                <Text style={{ width:280 }}>{t('lopd.section2.comunicacionItem6')}</Text>
                                            </View>
                                        </View>
                                </View>
                            </View>
                            {/* <View style={{marginBottom: 20, paddingTop: 20, marginHorizontal: '1cm'}} fixed></View> */}
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.section3.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section3.p1')}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item1')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item2')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item3')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item4')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item5')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item6')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.item7')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('lopd.section3.p2')}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.encItem1')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.encItem2')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.encItem3')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={{ marginHorizontal: 8 }}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.section3.encItem4')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('lopd.section3.p3')}</Text>
                                <Text style={styles.p}>{t('lopd.section3.p4')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.section4.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section4.p1')}</Text>
                                <Text style={styles.p}>{t('lopd.section4.p2')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.owners.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <View style={styles.table}>
                                    <View style={styles.tableRow}> 
                                        <View style={styles.tableColIzq}> 
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.responsable')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.responsableValue', { razonSocial: finca.razonSocial, nif: finca.nif, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia })}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.baseJuridica')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.baseJuridicaValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.fines')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.finesValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.categoriasDatos')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.categoriasDatosValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.categoriaDestinatarios')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.categoriaDestinatariosValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.categoriaAfectados')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.categoriaAfectadosValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.transferencias')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.transferenciasValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.plazoSupresion')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.owners.plazoSupresionValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableColIzq, { justifyContent: 'center' }]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.medidasSeguridad')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>
                                                <Text>{t('lopd.owners.medida1')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida2')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida3')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida4')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida5')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida6')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida7')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.owners.medida8')}{'\n'}{'\n'}</Text>
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        {detailsLOPD.maintenance ?
                            <Page style={styles.body}>
                                <View style={styles.pageHeader} fixed>
                                    <View >
                                        <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    </View>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={styles.h3}>{t('lopd.surveillance.title')}</Text>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <View style={styles.table}>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.responsable')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.owners.responsableValue', { razonSocial: finca.razonSocial, nif: finca.nif, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia })}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.baseJuridica')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.baseJuridicaValue1')}{'\n'}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.baseJuridicaValue2')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.fines')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.finesValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.categoriasDatos')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.categoriasDatosValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.categoriaDestinatarios')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.categoriaDestinatariosIntro')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.surveillance.destItem1')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.surveillance.destItem2')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.surveillance.destItem3')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.surveillance.destItem4')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.categoriaAfectados')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.categoriaAfectadosValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.transferencias')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.transferenciasValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.plazoSupresion')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.plazoSupresionValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={[styles.tableCol, { justifyContent: 'center' }]}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.surveillance.medidasSeguridad')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>
                                                    <Text>{t('lopd.surveillance.medida1')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.surveillance.medida2')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.surveillance.medida3')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.surveillance.medida4')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.surveillance.medida5')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.surveillance.medida6')}</Text>
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </Page>
                        : null}
                        {detailsLOPD.workers ? 
                            <Page style={styles.body}>
                                <View style={styles.pageHeader} fixed>
                                    <View >
                                        <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    </View>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={styles.h3}>{t('lopd.employees.title')}</Text>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <View style={styles.table}>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.responsable')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.owners.responsableValue', { razonSocial: finca.razonSocial, nif: finca.nif, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia })}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.baseJuridica')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.employees.baseJuridicaValue1')}{'\n'}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.baseJuridicaValue2')}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.baseJuridicaValue3')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.fines')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.employees.finesValue')}{'\n'}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem1')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem2')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem3')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem4')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem5')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem6')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem7')}</Text>
                                                <Text style={styles.tableCell}>• {t('lopd.employees.finesItem8')}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.finesItem9')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.categoriasDatos')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriasDatosValue1')}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriasDatosValue2')}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriasDatosValue3')}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriasDatosValue4')}</Text>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriasDatosValue5')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.categoriaDestinatarios')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriaDestinatariosValue')}</Text>
                                                </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.categoriaAfectados')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.employees.categoriaAfectadosValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.transferencias')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.surveillance.transferenciasValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={styles.tableCol}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.plazoSupresion')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>{t('lopd.employees.plazoSupresionValue')}</Text>
                                            </View>
                                        </View>
                                        <View style={styles.tableRow}>
                                            <View style={[styles.tableCol, { justifyContent: 'center' }]}>
                                                <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.owners.medidasSeguridad')}</Text>
                                            </View>
                                            <View style={styles.tableCol}>
                                                <Text style={styles.tableCell}>
                                                    <Text>{t('lopd.employees.medida1')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.employees.medida2')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.employees.medida3')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.employees.medida4')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.employees.medida5')}{'\n'}{'\n'}</Text>
                                                    <Text>{t('lopd.employees.medida6')}</Text>
                                                    <Text>{t('lopd.employees.medida7')}</Text>
                                                </Text>
                                            </View>
                                        </View>
                                    </View>
                                </View>
                            </Page>
                        : null}
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.encargado.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.encargado.p1')}</Text>
                                <Text style={styles.p}>{t('lopd.encargado.p2')}</Text>
                                <Text style={styles.p}>{t('lopd.encargado.p3')}</Text>
                            </View>
                            
                            <View style={{ marginHorizontal: '1cm' }}>                             
                                 <View style={styles.table}>
                                    <View style={styles.tableRowHeader}> 
                                        <View style={styles.tableColHeader}> 
                                            <Text style={styles.tableCell}>{t('lopd.encargado.tableHeader', { razonSocial: aaff.razonSocial, nif: aaff.nif })}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.encargado.colResponsable')}</Text>
                                        </View>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.encargado.colTratamientos')}</Text>
                                        </View>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.encargado.colTransferencias')}</Text>
                                        </View>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.encargado.colMedidas')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={styles.tableCell}>{t('lopd.encargado.responsableValue', { razonSocial: finca.razonSocial, nif: finca.nif })}</Text>
                                        </View>
                                        <View style={styles.tableColIzq}>
                                            <Text style={styles.tableCell}>{t('lopd.encargado.tratamientosValue')}</Text>
                                        </View>
                                        <View style={styles.tableColIzq}>
                                            <Text style={styles.tableCell}>{t('lopd.encargado.transferenciasValue')}</Text>
                                        </View>
                                        <View style={styles.tableColIzq}>
                                            <Text style={styles.tableCell}>
                                                <Text>{t('lopd.encargado.medida1')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida2')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida3')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida4')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida5')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida6')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida7')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida8')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida9')}{'\n'}{'\n'}</Text>
                                                <Text>{t('lopd.encargado.medida10')}{'\n'}{'\n'}</Text>
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        {detailsLOPD.maintenance ?
                            <Page style={styles.body}>
                                <View style={styles.pageHeader} fixed>
                                    <View >
                                        <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                    </View>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={styles.h3}>{t('lopd.reno.section6Title')}</Text>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={styles.p}>{t('lopd.videoInfo.intro')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.p2')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.p3')}</Text>
                                    <Text style={styles.p}>{t('lopd.section6.impagoP4')}</Text>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={styles.h3}>{t('lopd.reno.section6_1Title')}</Text>
                                </View>
                                <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={styles.p}>{t('lopd.videoInfo.introTemplate', { razonSocial: finca.razonSocial })}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.responsableQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.responsableLabel')}{finca.razonSocial}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.dirPostal')}{finca.direccion}, {finca.codigoPostal}, {finca.municipio} ({finca.provincia})</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.dirEmail')}{finca.emailContacto}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.datosQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.datosP1')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.datosP2')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.captamosQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.captamosAnswer')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.tratamientoQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.tratamientoIntro')}</Text>
                                    <View style={styles.ul}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>a)</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.tratamientoA')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>b)</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.tratamientoB')}</Text>
                                        </View>
                                    </View>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.legitimacionQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.legitimacionP1')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.legitimacionP2', { nif: finca.nif })}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.legitimacionP3')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.tiempoQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.tiempoAnswer')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.derechosQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.derechosIntro')}</Text>
                                    <View style={styles.ul}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.derechoAcceso', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.derechoRectificacion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.derechoOposicion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.derechoSupresion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.derechoPortabilidad', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.videoInfo.derechoLimitacion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                    </View>
                                    <Text style={styles.p}>{t('lopd.videoInfo.ejercerDerechos', { direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia, emailContacto: finca.emailContacto })}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.dniRequerido')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.reclamacion')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.comunicacionQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.comunicacionAnswer')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.sinTransferencias')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.videoInfo.contacto')}</Text>
                                    <Text style={styles.p}>{t('lopd.videoInfo.contactoAnswer', { emailContacto: finca.emailContacto })}</Text>
                                </View>
                            </Page>
                        : null }
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.reno.section7Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section5.intro')}</Text>
                                <Text style={[styles.p, {textDecoration:'underline', lineHeight: 1.2}]}>{t('lopd.section5.aviso')}</Text>
                                <Text style={styles.h4}>{t('lopd.reno.section7_1Title')}</Text>

                                <Text style={styles.br} />
                                <Text style={[styles.p, {textDecoration:'underline', textAlign:'center', lineHeight: 1.2}]}>{t('lopd.reno.section5_1InfoBasica')}</Text>
                                <Text style={[styles.p, {textDecoration:'underline', textAlign:'center', lineHeight: 1.2}]}>{t('lopd.reno.section5_1InfoBasicaSub')}</Text>
                                <Text style={styles.p}>{t('lopd.reno.section5_1Intro', { razonSocial: finca.razonSocial })}</Text>
                                <View style={styles.table}>
                                    <View style={styles.tableRowHeader}> 
                                        <View style={styles.tableColHeader}> 
                                            <Text style={[styles.tableCell, styles.textoItalic, {textDecoration:'underline'}]}>{t('lopd.section5_1.tableHeader')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.reno.responsable')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.reno.responsableTableValue', { razonSocial: finca.razonSocial, nif: finca.nif, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia })}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.section5_1.finalidad')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.section5_1.finalidadValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.section5_1.legitimacion')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.section5_1.legitimacionValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.section5_1.destinatarios')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.section5_1.destinatariosValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.section5_1.derechos')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.section5_1.derechosValue')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableColIzq}>
                                            <Text style={[styles.tableCell, styles.textoNegrita]}>{t('lopd.section5_1.infoAdicional')}</Text>
                                        </View>
                                        <View style={styles.tableColDer}>
                                            <Text style={styles.tableCell}>{t('lopd.reno.infoAdicionalValue', { emailContacto: finca.emailContacto })}</Text>
                                        </View>
                                    </View>
                                </View>
                                <Text style={styles.h4}>{t('lopd.reno.section7_2Title')}</Text>
                                <Text style={[styles.p, {textDecoration:'underline', textAlign:'center', lineHeight: 1.2}]}>{t('lopd.section5_2.infoAdicionalTitle')}</Text>
                                <Text style={styles.p}>{t('lopd.section5_2.introTemplate', { razonSocial: finca.razonSocial })}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.responsableQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.responsableLabel')}{finca.razonSocial}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.dirPostal')}{finca.direccion}, {finca.codigoPostal}, {finca.municipio} ({finca.provincia})</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.dirEmail')}{finca.emailContacto}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.datosQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.datosAnswer1')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.datosAnswer2')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.captamosQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.captamosAnswer')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.tratamientoQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.tratamientoAnswer')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.legitimacionQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.legitimacionAnswer1')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.legitimacionAnswer2')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.tiempoQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.tiempoAnswer')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.derechosQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.derechosIntro')}</Text>
                                    <View style={styles.ul}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section5_2.derechoAcceso', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section5_2.derechoRectificacion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section5_2.derechoOposicion', { razonSocial: finca.razonSocial })} {t('lopd.section5_2.derechoOposicionExtra', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section5_2.derechoSupresion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section5_2.derechoPortabilidad', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8}]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section5_2.derechoLimitacion', { razonSocial: finca.razonSocial })}</Text>
                                        </View>
                                    </View>
                                    <Text style={styles.p}>{t('lopd.section5_2.ejercerDerechos', { direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia, emailContacto: finca.emailContacto })}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.dniRequerido')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.reclamacion')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.comunicacionQuestion')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.comunicacionAnswer')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.sinTransferencias')}</Text>
                                    <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section5_2.contacto')}</Text>
                                    <Text style={styles.p}>{t('lopd.section5_2.contactoAnswer', { emailContacto: finca.emailContacto })}</Text>
                            </View>
                        </Page>
                        {detailsLOPD.workers ? 
                            <>
                                <Page style={styles.body}>
                                    <View style={styles.pageHeader} fixed>
                                        <View >
                                            <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                        </View>
                                    </View>
                                    <View style={{ marginHorizontal: '1cm' }}>
                                        <Text style={styles.h3}>{t('lopd.reno.section8Title')}</Text>
                                    </View>
                                    <View style={{ marginHorizontal: '1cm' }}>
                                    <Text style={[styles.p, {textDecoration:'underline', lineHeight: 1.2}]}>{t('lopd.reno.section8Aviso')}</Text>
                                        <Text style={[styles.p, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section10.privacidadTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.privacidadIntro', { razonSocial: finca.razonSocial })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.responsableTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.responsableText', { razonSocial: finca.razonSocial, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia, emailContacto: finca.emailContacto })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.definicionTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.definicionP1')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.definicionP2')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.datosCaptadosTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.datosCaptadosIntro', { razonSocial: finca.razonSocial })}</Text>
                                        <View style={styles.ul}>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={styles.textoNegrita}>{t('lopd.section8.cantidadTitle')}</Text>{t('lopd.section8.cantidadText')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem3')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem4')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem5')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem6')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem7')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem8')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem9')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.datoItem10')}</Text>
                                            </View>
                                        </View>
                                        <Text style={styles.p}>{t('lopd.section10.categoriasEspeciales', { razonSocial: finca.razonSocial })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.consentimiento', { razonSocial: finca.razonSocial })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.tratamientoTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.tratamientoA')} {t('lopd.section10.tratamientoAIntro')}</Text>
                                        <View style={styles.ul}>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem1')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem3')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem4')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem5')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem6')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem7')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem8')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem9')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tratamientoAItem10')}</Text>
                                            </View>
                                        </View>
                                        <Text style={styles.p}>{t('lopd.section10.legitimacionTitle')}</Text>
                                        <View style={styles.ul}>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.legitimacionItem1', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.legitimacionItem2')}</Text>
                                            </View>
                                        </View>
                                        <Text style={styles.p}>{t('lopd.section10.tercerosTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.tercerosIntro', { razonSocial: finca.razonSocial })}</Text>
                                        <View style={styles.ul}>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tercerosItem1')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tercerosItem2')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section10.tercerosItem3')}</Text>
                                            </View>
                                        </View>
                                        <Text style={styles.p}>{t('lopd.section10.sinTransferencias', { razonSocial: finca.razonSocial })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.cesionAdmin')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.conservacionTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.conservacionText', { razonSocial: finca.razonSocial })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.derechosTitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.derechosIntro')}</Text>
                                        <View style={styles.ul}>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={{textDecoration:'underline'}}>{t('lopd.section10.derechoAcceso')}</Text>{t('lopd.section10.derechoAccesoText', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={{textDecoration:'underline'}}>{t('lopd.section10.derechoRectificacion')}</Text>{t('lopd.section10.derechoRectificacionText', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={{textDecoration:'underline'}}>{t('lopd.section10.derechoOposicion')}</Text>{t('lopd.section10.derechoOposicionText')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={{textDecoration:'underline'}}>{t('lopd.section10.derechoSupresion')}</Text>{t('lopd.section10.derechoSupresionText', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={{textDecoration:'underline'}}>{t('lopd.section10.derechoPortabilidad')}</Text>{t('lopd.section10.derechoPortabilidadText', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}><Text style={{textDecoration:'underline'}}>{t('lopd.section10.derechoLimitacion')}</Text>{t('lopd.section10.derechoLimitacionText', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                        </View>
                                        <Text style={styles.p}>{t('lopd.section10.ejercerDerechos', { razonSocial: finca.razonSocial, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia, emailContacto: finca.emailContacto })}</Text>
                                        <Text style={styles.p}>{t('lopd.section10.reclamacion')}</Text>
                                        <Text style={[styles.p]}>{t('lopd.section10.firmaLugar', { municipio: finca.municipio })}</Text>
                                        <Text style={[styles.p]}>{t('lopd.section10.firmaEmpleado')}</Text>
                                    </View>
                                </Page>
                                <Page style={styles.body}>
                                    <View style={styles.pageHeader} fixed>
                                        <View >
                                            <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                        </View>
                                    </View>
                                    <View style={{ marginHorizontal: '1cm' }}>
                                        <Text style={[styles.p, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.workerSecrecy.title')}</Text>
                                        <Text style={[styles.p, {textDecoration:'underline', textAlign:'center'}]}>{t('lopd.workerSecrecy.subtitle')}</Text>
                                        <Text style={styles.p}>{t('lopd.workerSecrecy.compromiso', { razonSocial: finca.razonSocial, nif: finca.nif, direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia })}</Text>
                                        <View style={styles.ul}>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>1.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion1', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>2.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion2', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>3.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion3')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>4.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion4')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>5.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion5', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>6.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion6')}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>7.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion7', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                            <View style={styles.ol}>
                                                <Text style={[styles.lista, { marginHorizontal: 8 }]}>8.</Text>
                                                <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.workerSecrecy.obligacion8', { razonSocial: finca.razonSocial })}</Text>
                                            </View>
                                        </View>
                                        <Text style={[styles.p]}>{t('lopd.workerSecrecy.firmaLugar', { municipio: finca.municipio })}</Text>
                                        <Text style={[styles.p]}>{t('lopd.workerSecrecy.firmaEmpleado')}</Text>
                                    </View>
                                </Page>
                            </>
                        : null }
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.reno.section9Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.reno.section9_1Title')}</Text>
                                <Text style={styles.p}>{t('lopd.reno.section9_1Intro')}</Text>
                                <Text style={styles.p}>{t('lopd.section6.impagoP1')}</Text>
                                <Text style={styles.p}>{t('lopd.section6.impagoP2')}</Text>
                                <Text style={styles.p}>{t('lopd.section6.impagoP3')}</Text>
                                <Text style={styles.p}>{t('lopd.section6.impagoP4')}</Text>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.reno.section9_2Title')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_1.p1')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_1.p2')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_1.p3')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_1.p4')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_1.p5')}</Text>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.reno.section9_3Title')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_2.p1')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_2.p2')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_2.p3')}</Text>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.reno.section9_4Title')}</Text>
                                <Text style={styles.p}>{t('lopd.reno.section9_4P1')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_3.p2')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_3.p3')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_3.p4')}</Text>
                                <Text style={styles.p}>{t('lopd.section6_3.p5')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.reno.section10Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h4}>{t('lopd.reno.section10_1Title')}</Text>
                                <View style={styles.table}>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.section7.nombrePresidente')}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{finca.nombrePresidente}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.section7.dni')}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{finca.nifPresidente}</Text>
                                        </View>
                                    </View>
                                </View>
                                <Text style={styles.br} />
                                <Text style={[styles.p, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section7.confidencialidadTitle')}</Text>
                                <Text style={[styles.p, {textDecoration:'underline', textAlign:'center'}]}>{t('lopd.section7.confidencialidadSubtitle')}</Text>
                                <Text style={[styles.p]}>{t('lopd.section7.compromiso', { nombrePresidente: finca?.nombrePresidente === null || finca?.nombrePresidente === '' ? "____________" : finca?.nombrePresidente, nifPresidente: finca?.nifPresidente === null || finca?.nifPresidente === '' ? "____________" : finca.nifPresidente, razonSocial: finca.razonSocial, nif: finca.nif })}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8 }]}>1.</Text>
                                        <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section7.obligacion1', { razonSocial: finca.razonSocial })}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8 }]}>2.</Text>
                                        <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section7.obligacion2', { razonSocial: finca.razonSocial })}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8 }]}>3.</Text>
                                        <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section7.obligacion3')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, styles.textoNormal, { marginHorizontal: 8 }]}>4.</Text>
                                        <Text style={{marginRight: '2cm', fontSize: 9}}>{t('lopd.section7.obligacion4', { razonSocial: finca.razonSocial })}</Text>
                                    </View>
                                    <Text style={[styles.p]}>{t('lopd.section7.firmaLugar', { municipio: finca.municipio })}</Text>
                                    <Text style={[styles.p]}>{t('lopd.section7.firmaPresidente')}</Text>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.reno.section10_2Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={[styles.h4, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.whatsapp.consentimientoTitle')}</Text>
                                <Text style={[styles.p, styles.textoItalic]}>{t('lopd.whatsapp.intro', { razonSocial: finca.razonSocial })}</Text>
                                <Text style={[styles.p, styles.textoItalic]}>{t('lopd.whatsapp.p2')}</Text>
                                <Text style={[styles.p, styles.textoItalic]}>{t('lopd.whatsapp.p3')}</Text>

                                <View style={{flexDirection: "row", width:'90%'}}>
                                    <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                    <Text style={[styles.p, {textDecoration:'underline'}]}>{t('lopd.whatsapp.si')}</Text>
                                </View>
                                <View style={{flexDirection: "row", width:'90%'}}>
                                    <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                    <Text style={[styles.p, {textDecoration:'underline'}]}>{t('lopd.whatsapp.no')}</Text>
                                </View>


                                <Text style={[styles.p, {marginTop:20}]}>{t('lopd.whatsapp.nombreApellidos')}</Text>
                                <Text style={styles.p}>{t('lopd.whatsapp.dniLabel')}</Text>
                                <Text style={[styles.p]}>{t('lopd.whatsapp.firmaLugar', { municipio: finca.municipio })}</Text>
                                <Text style={[styles.p]}>{t('lopd.whatsapp.firma')}</Text>

                                <Text style={[styles.p, styles.textoItalic, {marginTop:50, fontSize: 7}]}>
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerResponsable')}</Text>{t('lopd.whatsapp.footerDatos')}
                                    {finca.razonSocial} con <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerNIF')}</Text> {finca.nif}.
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerDirPostal')}</Text> {finca.direccion} {finca.codigoPostal} {finca.municipio} ({finca.provincia})
                                    {t('lopd.common.inNameOfCommunity')}<Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerFinalidad')}</Text>
                                    {t('lopd.whatsapp.footerFinalidadText')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerLegitimacion')}</Text>
                                    {t('lopd.whatsapp.footerLegitimacionText')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerDestinatarios')}</Text>
                                    {t('lopd.whatsapp.footerDestinatariosText')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerDerechos')}</Text>
                                    {t('lopd.whatsapp.footerDerechosText')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.whatsapp.footerInfoAdicional')}</Text>
                                    {t('lopd.whatsapp.footerInfoAdicionalText')}</Text>
                                <Text style={[styles.p, {textDecoration:'underline', lineHeight: 1.2}]}>{t('lopd.whatsapp.avisoMasivo')}</Text>
                                <Text style={[styles.p, {textDecoration:'underline', lineHeight: 1.2}]}>{t('lopd.whatsapp.avisoPermiso')}</Text>
                            </View>
                            {/* <View style={{marginBottom: 20, paddingTop: 20, marginHorizontal: '1cm'}} fixed></View> */}
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.reno.section12Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section8.p1')}</Text>
                                <Text style={[styles.p, styles.textoItalic]}>{t('lopd.section8.quote')}</Text>
                                <Text style={styles.p}>{t('lopd.section8.p2')}</Text>
                                <Text style={styles.p}>{t('lopd.section8.p3')}</Text>
                                <Text style={styles.p}>{t('lopd.section8.p4')}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, {textDecoration:'underline'}]}>{t('lopd.section8.cantidadTitle')}</Text>{t('lopd.section8.cantidadText')}</Text>
                                    </View>
                                    <View style={[styles.ul, {marginLeft:20}]}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.cantidadItem1')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.cantidadItem2')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.cantidadItem3')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.cantidadItem4')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.cantidadItem5')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, {textDecoration:'underline'}]}>{t('lopd.section8.extensionTitle')}</Text>{t('lopd.section8.extensionText')}</Text>
                                    </View>
                                    <View style={[styles.ul, {marginLeft:20}]}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.extensionItem1')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.extensionItem2')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.extensionItem3')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, {textDecoration:'underline'}]}>{t('lopd.section8.conservacionTitle')}</Text>{t('lopd.section8.conservacionText')}</Text>
                                    </View>
                                    <View style={[styles.ul, {marginLeft:20}]}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.conservacionItem1')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.conservacionItem2')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.conservacionItem3')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={[styles.textoNegrita, {textDecoration:'underline'}]}>{t('lopd.section8.accesibilidadTitle')}</Text>{t('lopd.section8.accesibilidadText')}</Text>
                                    </View>
                                    <View style={[styles.ul, {marginLeft:20}]}>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem1')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem2')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem3')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem4')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem5')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem6')}</Text>
                                        </View>
                                        <View style={styles.ol}>
                                            <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                            <Text style={{marginRight: '2cm'}}>{t('lopd.section8.accesibilidadItem7')}</Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h3}>{t('lopd.reno.section13Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.section9.intro')}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={{textDecoration:'underline'}}>{t('lopd.section9.deberInformar')}</Text>{t('lopd.section9.deberInformarText')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={{textDecoration:'underline'}}>{t('lopd.reno.contrato')}</Text>{t('lopd.reno.contratoText1')}</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.reno.contratoText2')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={{textDecoration:'underline'}}>{t('lopd.section9.acceso')}</Text>{t('lopd.section9.accesoText')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>*</Text>
                                        <Text style={{marginRight: '2cm'}}><Text style={{textDecoration:'underline'}}>{t('lopd.section9.registro')}</Text>{t('lopd.section9.registroText')}</Text>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h4}>{t('lopd.reno.section13_1Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={[styles.p, {textDecoration:'underline'}]}>{t('lopd.section9_1.obligacion')}</Text>
                                <View style={[styles.table, {width:'90%', marginTop:'30px'}]}>
                                    <View style={styles.tableRowHeader}>
                                        <View style={styles.tableColHeader}>
                                            <Text style={styles.tableCell}>{t('lopd.section9_1.registroHeader')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.registro')}</Text>
                                        </View>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.dia')}</Text>
                                        </View>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.mes')}</Text>
                                        </View>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.anio')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:100}]}>
                                                {t('lopd.section9_1.descripcion')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:100}]}>
                                                {t('lopd.section9_1.medidas')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:100}]}>
                                                {t('lopd.section9_1.firmaResponsable')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <View style={[styles.table, {width:'90%', marginTop:'30px'}]}>
                                    <View style={styles.tableRowHeader}>
                                        <View style={styles.tableColHeader}>
                                            <Text style={styles.tableCell}>{t('lopd.section9_1.comunicacionHeader')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.registro')}</Text>
                                        </View>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.dia')}</Text>
                                        </View>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.mes')}</Text>
                                        </View>
                                        <View style={[styles.tableCol, {width: "25%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {textAlign:'center'}]}>{t('lopd.section9_1.anio')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                        <View style={[styles.tableCol, {width: "25%", height:20}]}> 
                                            <Text style={styles.tableCell}></Text> 
                                        </View> 
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, {height:50}]}>
                                                {t('lopd.section9_1.responsableSeguridad')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:100}]}>
                                                {t('lopd.section9_1.naturaleza')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:100}]}>
                                                {t('lopd.section9_1.consecuencias')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:100}]}>
                                                {t('lopd.section9_1.medidasRemedio')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={[styles.tableCol, {width: "100%"}]}>
                                            <Text style={[styles.tableCell, styles.textoNegrita, {height:50}]}>
                                                {t('lopd.section9_1.firmaResponsable')}{'\n'}
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h4}>{t('lopd.reno.section13_2Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section9_2.recepcion')}</Text>
                                <Text style={styles.p}>{t('lopd.section9_2.recepcionText', { razonSocial: finca.razonSocial })}</Text>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section9_2.coordinacion')}</Text>
                                <Text style={styles.p}>{t('lopd.section9_2.coordinacionText')}</Text>
                                <Text style={[styles.p, styles.textoNegrita]}>{t('lopd.section9_2.respuesta')}</Text>
                                <Text style={styles.p}>{t('lopd.section9_2.respuestaText1')}<Text style={styles.textoNegrita}>{t('lopd.section9_2.respuestaTextBold')}</Text>{t('lopd.section9_2.respuestaText2')}<Text style={{textDecoration:'underline'}}>{t('lopd.section9_2.respuestaTextUnderline')}</Text>{t('lopd.section9_2.respuestaText3')}</Text> 
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h4}>{t('lopd.rightsForm.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                            <View style={[styles.table, {width:'90%'}]}>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.nombre')}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.dniLabel')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.domicilio')}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.cp')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.poblacion')}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.provincia')}</Text>
                                        </View>
                                    </View>
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{t('lopd.rightsForm.email')}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}></Text>
                                        </View>
                                    </View>
                                </View>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.rightsForm.solicita')}</Text><Text style={{fontSize:8}}>{t('lopd.rightsForm.marcarOpciones')}</Text></Text>
                                <View>
                                    <View style={{flexDirection: "row", width:'90%'}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                        <Text style={[styles.p, {textDecoration:'underline'}]}>{t('lopd.rightsForm.derechoAcceso')}</Text>
                                    </View>
                                    <View style={{flexDirection: "row"}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:35}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.correoPostal')}</Text>
                                    </View>
                                    <View style={{flexDirection: "row"}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:35}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.emailIndicado')}</Text>
                                    </View>
                                    <View style={{flexDirection: "row", width:'90%'}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.derechoRectificar')}<Text style={styles.textoNegrita}>{t('lopd.rightsForm.rectificar')}</Text>{t('lopd.rightsForm.rectificarText')}</Text>
                                    </View>
                                    <View style={{width:'95%', marginBottom:20}}>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                    </View>
                                    <View style={{flexDirection: "row", width:'90%'}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.derechoRectificar')}<Text style={styles.textoNegrita}>{t('lopd.rightsForm.derechoSuprimir')}</Text>{t('lopd.rightsForm.suprimirText')}</Text>
                                    </View>
                                    <View style={{width:'95%', marginBottom:20}}>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                    </View>
                                    <View style={{flexDirection: "row", width:'90%'}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.derechoRectificar')}<Text style={styles.textoNegrita}>{t('lopd.rightsForm.derechoLimitar')}</Text>{t('lopd.rightsForm.limitarText')}</Text>
                                    </View>
                                    <View style={{width:'95%', marginBottom:20}}>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                    </View>
                                    <View style={{flexDirection: "row", width:'90%'}} break>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.derechoRectificar')}<Text style={styles.textoNegrita}>{t('lopd.rightsForm.derechoPortar')}</Text>{t('lopd.rightsForm.portarText')}</Text>
                                    </View>
                                    <View style={{width:'95%', marginBottom:20}}>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                    </View>
                                    <View style={{flexDirection: "row", width:'90%'}}>
                                        <Text style={[styles.cuadrado, {marginTop:5, marginLeft:15}]}></Text>
                                        <Text style={styles.p}>{t('lopd.rightsForm.derechoRectificar')}<Text style={styles.textoNegrita}>{t('lopd.rightsForm.derechoOponerme')}</Text>{t('lopd.rightsForm.oponermeText')}</Text>
                                    </View>
                                    <View style={{width:'95%', marginBottom:20}}>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                        <Text style={[styles.linea, {marginLeft:35}]}></Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('lopd.rightsForm.verificacion')}</Text>
                                <Text style={styles.p}>{t('lopd.rightsForm.rectificacionDoc')}</Text>
                                <Text style={styles.p}>{t('lopd.rightsForm.infoBasicaIntro', { razonSocial: finca.razonSocial })}</Text>
                                <Text style={[styles.p, styles.textoItalic, {fontSize:7}]}>
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.rightsForm.responsableLabel')}</Text>
                                    {finca.razonSocial} con CIF {finca.nif}.
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.rightsForm.finalidadLabel')}</Text>
                                    {t('lopd.rightsForm.finalidadValue')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.rightsForm.basesLabel')}</Text>
                                    {t('lopd.rightsForm.basesValue')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.rightsForm.destinatariosLabel')}</Text>
                                    {t('lopd.rightsForm.destinatariosValue')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.rightsForm.plazoLabel')}</Text>
                                    {t('lopd.rightsForm.plazoValue')}
                                    <Text style={styles.textoNegritaItalic}>{t('lopd.rightsForm.derechosLabel')}</Text>
                                    {t('lopd.rightsForm.derechosValue', { direccion: finca.direccion, codigoPostal: finca.codigoPostal, municipio: finca.municipio, provincia: finca.provincia, emailContacto: finca.emailContacto })}<Link src="https://www.aepd.es">{t('lopd.rightsForm.aepd')}</Link>{t('lopd.rightsForm.derechosValueEnd')}</Text>
                                <Text style={styles.p}>{t('lopd.reno.firmaCliente')}</Text>
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.h4}>{t('lopd.reno.section14Title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={styles.p}>{t('lopd.conclusions.intro')}</Text>
                                <View style={styles.ul}>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.conclusions.item1')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.conclusions.item2')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.conclusions.item3')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.conclusions.item4')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.conclusions.item5')}</Text>
                                    </View>
                                    <View style={styles.ol}>
                                        <Text style={[styles.lista, { marginHorizontal: 8 }]}>•</Text>
                                        <Text style={{marginRight: '2cm'}}>{t('lopd.conclusions.item6')}</Text>
                                    </View>
                                </View>
                                <Text style={styles.p}>{t('lopd.conclusions.firma')}</Text>
                                <Image src={Firma} style={{width:"100px"}} />
                            </View>
                        </Page>
                        <Page style={styles.body}>
                            <View style={styles.pageHeader} fixed>
                                <View >
                                    <Image src={Logo} style={{marginTop: 10, width:'18%', paddingLeft:5}} />
                                </View>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <Text style={[styles.h4, {marginTop:0, textDecoration:'underline', textAlign:'center'}]}>{t('lopd.noAccessAgreement.title')}</Text>
                            </View>
                            <View style={{ marginHorizontal: '1cm' }}>
                                <View style={{flexDirection: "row"}}>
                                    <Text style={[styles.p, {}]}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.comunidad')}</Text>..................</Text>
                                    <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.cif')}</Text>..................</Text>
                                </View>
                                <View style={{flexDirection: "row"}}>
                                    <Text style={[styles.p, {}]}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.proveedor')}</Text>..................</Text>
                                    <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.cifProveedor')}</Text>..................</Text>
                                </View>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.servicioLabel')}</Text></Text>
                                <Text style={styles.p}>............ , a .... de .............. de 20...</Text>
                                <Text style={[styles.p, styles.textoNegrita, {textAlign: 'center'}]}>{t('lopd.noAccessAgreement.clausulas')}</Text>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.primera')}</Text>{t('lopd.noAccessAgreement.primeraText')}</Text>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.segunda')}</Text>{t('lopd.noAccessAgreement.segundaText')}</Text>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.tercera')}</Text>{t('lopd.noAccessAgreement.terceraText')}</Text>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.cuarta')}</Text>{t('lopd.noAccessAgreement.cuartaText')}</Text>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.quinta')}</Text>{t('lopd.noAccessAgreement.quintaText')}</Text>
                                <Text style={styles.p}><Text style={styles.textoNegrita}>{t('lopd.noAccessAgreement.sexta')}</Text>{t('lopd.noAccessAgreement.sextaText')}</Text>
                                <Text style={styles.p}>{t('lopd.noAccessAgreement.constancia')}</Text>
                                <Text style={styles.p}></Text>
                                <View style={{flexDirection: "row", justifyContent:'space-between'}}>
                                    <Text style={[styles.p, {fontSize:8}]}>{t('lopd.reno.adminFincas')}</Text>
                                    <Text style={[styles.p, {fontSize:8, textAlign:'left'}]}>{t('lopd.reno.proveedor')}</Text>
                                </View>
                                <View style={{flexDirection: "row", justifyContent:'space-between'}}>
                                    <Text style={[styles.p, {fontSize:8}]}>{t('lopd.noAccessAgreement.secretarioAdmin')}</Text>
                                    <Text style={[styles.p, {fontSize:8}]}></Text>
                                </View>
                                <View style={{flexDirection: "row", justifyContent:'space-between'}}>
                                    <Text style={[styles.p, {fontSize:8}]}>{t('lopd.noAccessAgreement.fdo')}</Text>
                                    <Text style={[styles.p, {fontSize:8}]}>{t('lopd.noAccessAgreement.fdo')}</Text>
                                </View>
                            </View>
                            <View style={{marginBottom: 20, paddingTop: 20, marginHorizontal: '1cm'}} fixed></View>
                        </Page>
                    </Document>
                </PDFHandler>
            }
        </>
     );
}
 
export default withRouter(DocumentacionLOPD);